@if (organizationDetail$ | async; as organizationDetail) {
  @if (!hideTitle()) {
    <h2 class="title-imprint">Impressum, Datenschutz und Nutzungsbedingungen</h2>
  }
  <div class="text-imprint" [innerHtml]="textImprint"></div>
  <div class="text-imprint" [innerHtml]="textDataProtection"></div>
}
<p>
  {{version}}
</p>
<p>
  {{userId$ | async}}
</p>